import styled from "styled-components";
import { Link } from "@viagogo/core/ui";

// https://developer.spotify.com/documentation/design#using-our-logo
const SPOTIFY_LIGHT_GREEN = "#1dd75f";

const Container = styled(Link)`
  background-color: ${SPOTIFY_LIGHT_GREEN};
  color: black;
  padding: ${({ theme, $isCompact }) => ($isCompact ? theme.spacing(2, 3) : theme.spacing(2.5, 4))};
  border-radius: ${({ theme, $isCompact }) => ($isCompact ? theme.borderRadius.l : theme.borderRadius.xxl)};
  font-size: 12px;
  font-weight: 500;
  line-height: 16px;
  white-space: nowrap;
  cursor: pointer;
  @media only screen and (min-width: ${({ theme }) => theme.media.breakpoints.md}px) {
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
  }
`;

export const SpotifyGreenButton = (props) => <Container {...props}>{props.children}</Container>;
